import React, { useState, useEffect, Fragment } from 'react';
import { NavLink, useParams, useHistory } from "react-router-dom";
import { ConvertDateTime, HandleNotFoundResponse } from '../../../shared/helpers';
import { Editor } from '../../../shared';
import { UserChangeHistoryTabs } from './UserChangeHistoryTabs';
import { Loader } from '../../../shared/loaders';
import { UserChangeHistoryDetailModel } from './models/user.change.history.detail.model';
import { NotFoundResponseArea } from '../../../../src/shared/enums';
import { HttpResponse } from '../../../core';
import { ChangeHistoryService } from './services/change.history.service';
import { UserChangeHistoryDescription } from './UserChangeHistoryDescription';

interface RouteParams {
    id: string;
}

export const UserChangeHistoryDetail: React.FC = () => {
    const { id } = useParams<RouteParams>();
    const [result, setResult] = useState<UserChangeHistoryDetailModel | null>(null);
    const [parsedData, setParsedData] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const history = useHistory();
    const service = new ChangeHistoryService();

    const loadData = async () => {
        setIsLoading(true);
        try {
             const res: HttpResponse<UserChangeHistoryDetailModel> = await service.getChangeHistoryById(Number(id));
                if (res?.result) {
                    const data = res.result;

                    const object = {
                        ...(data.object),
                    };

                    setResult(data);
                    setParsedData(JSON.stringify(object, null, '\t'));
                }
        } catch (ex) {
            HandleNotFoundResponse(ex, NotFoundResponseArea.UserChangeHistories, history);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <Fragment>
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>
                        Details for User Change History '{result ? ConvertDateTime(result.created_at, 'LLL') : "..."}'
                    </h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <UserChangeHistoryTabs id={Number(id)} url="/user-change-history/detail/" />
                                {!isLoading && result && (
                                    <>
                                        <h5 className="mb-3">Basic Info</h5>
                                        <div className="row">
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">User</div>
                                                    <div className="card-body">
                                                        <NavLink to={`/user/detail/${result.item_id}`}>
                                                            {result.item_id}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">Event</div>
                                                    <div className="card-body">{result.event}</div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">Item Type</div>
                                                    <div className="card-body">{result.item_type}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">Changed By</div>
                                                    <div className="card-body">
                                                        <NavLink to={`/user/detail/${result.user_id}`}>
                                                            {result.user_name}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">IP</div>
                                                    <div className="card-body">{result.ip}</div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold">Created At</div>
                                                    <div className="card-body">{ConvertDateTime(result.created_at, 'LLL')}</div>
                                                </div>
                                            </div>
                                        </div>
                                         <div className="row mt-3">
                                            <div className="col-md-6">
                                                <h6>Description</h6>
                                                <UserChangeHistoryDescription result={result} />
                                            </div>
                                            {result.object && (
                                                <div className="col-md-6">
                                                    <h6>User Definition Before Changes</h6>
                                                    <Editor StringData={parsedData} FormateType="json" />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                {!isLoading && !result && (
                                    <div className="text-danger text-center">
                                        <p>No data found</p>
                                    </div>
                                )}
                                {isLoading && <Loader loading={isLoading} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
